#import "../fragments/wf-form-fragment.graphql"

query GetWfForm($formId: ID!) {
    form(id: $formId) {
        ...WfFormFragment
    }
}
